import axios from 'axios';
import { handleResponseError } from '../handleResponse/handleResponseError';
import { handleResponseSuccess } from '../handleResponse/handleResponseSuccess';
import { headers } from '../headers';

export function DELETE(url: string, payload: any): any {
    const h = headers(url);

    const id = payload.id ? payload.id : '';
    const query = payload.query ? payload.query : '';

    const path = `${url}${id}${query}`

    return axios.delete(path, {headers: h}).then(
        response => {
            return handleResponseSuccess(response);
        },
        e => {
            return handleResponseError(e.response);
        }
    );
}